<template>
    <div class="popup popup-about modal-in" :class="{ 'modal-in': isShow, 'modal-out': !isShow}"  style="display: block;" id="couponRulePopup">
        <div class="content-block">
            <div class="pop-nav">
                <a class="close-popup" @click="closeCouponRule()">
                    <img src="https://resource.rcclchina.com.cn/tui2/user_center/arrow_back.png">
                </a>
                <div class="pop-nav-title">使用规则</div>
            </div>
            <div class="coupon-popup-bg"></div>
            <div id="coupon-popup-content" v-html="couponRule">

            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "CouponRulePopup",
    props: {
        couponRule: {
            type: String
        },
        isShow: {
            type: Boolean
        },
        closeCouponRule: {
            type: Function
        }
    }
}
</script>

<style lang="less" scoped>
#couponRulePopup.popup {
    position: fixed;
    background-color: #F6F7F8;
    div.content-block {
        padding: 0px;
        margin: 0px;
        .pop-nav {
            display: block;
            position: relative;
            height: 50px;
            a {
                width: 50px;
                position: absolute;
                display: block;
                height: 100%;
                z-index: 1;
                img {
                    width: 10px;
                    position: relative;
                    left: 20px;
                    top: 16px;
                }
            }
            .pop-nav-title {
                position: relative;
                top: 15px;
                text-align: center;
            }
        }
        .coupon-popup-bg {
            height: 10px;
            background-color: #F6F7F8;
        }
        #coupon-popup-content {
            padding: 14px 21px;
            
            font-size: 12px;
            color: #666666;
            letter-spacing: 0;
            line-height: 20px;
        }
    }
}
#couponRulePopup.modal-out {
    transform: translate3d(100%, 0, 0);
}

</style>

<style lang="less">
#couponRulePopup #coupon-popup-content  p {
    margin: 0px;
}
</style>